/* eslint-disable no-console */
import { createSelector } from 'reselect'
import { initialState } from './reducer'

const selectAccount = (state) => state.accountList || initialState

const makeSelectAccount = () => createSelector(
  selectAccount,
  (state) => state
)

export {
  selectAccount,
  makeSelectAccount
}
